"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const NHRectangle = createSVGIcon(
  <>
    <rect
      x=".5"
      y=".5"
      width="49.11"
      height="73"
      rx="24.555"
      stroke="currentColor"
    />
    <path
      d="M20.705 26.803h1.315V18.79l6.279 8.013h1.105v-10.18h-1.329v7.817l-6.125-7.817h-1.245zM20.93 56.52h1.343v-4.503h5.566v4.503h1.357V46.34h-1.357v4.432h-5.566V46.34h-1.342z"
      fill="currentColor"
    />
    <path stroke="currentColor" d="M18.646 36.209 31.465 36.209" />
  </>,
  "NHRectangle",
  {
    viewBox: "0 0 51 74",
    titleAccess: "NHRectangle",
    fill: "none",
    className: legacyIconCls(),
  }
);
